import { useMediaQuery } from 'react-responsive'
import { useNewSidebar } from 'src/app/layouts/sidebar'

export interface ContentModalClasses {
  container: string
}

export function useContentModal() {
  const { isMinimized } = useNewSidebar()
  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' })

  // Calculate positioning based on sidebar state and device
  const getPositioningClasses = (): ContentModalClasses => {
    if (!isDesktop) {
      // Mobile: full screen replacing main content
      return {
        container: 'tw-fixed tw-inset-0 tw-z-30 tw-flex tw-flex-col tw-bg-white'
      }
    }

    // Desktop: CSS class-based positioning (mirrors main-content approach)
    const modalPositionClass = isMinimized ? 'modal-overlay-minimized' : 'modal-overlay-expanded'
    
    return {
      container: `${modalPositionClass} tw-fixed tw-top-16 tw-bottom-0 tw-left-0 tw-right-0 tw-z-30 tw-flex tw-flex-col tw-bg-white tw-shadow-lg`
    }
  }

  return {
    classes: getPositioningClasses(),
    isDesktop,
    isMinimized
  }
}

export default useContentModal